export default __webpack_public_path__ + "static/media/AnandRam.8380f267.png";